import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Layout from "./components/Layout";
import PageTransition from "./components/PageTransition";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import HeroAuto from "./pages/HeroAuto";
import ServicesSection from "./pages/ServicesSection";
import About from "./pages/AboutUs";
import Contact from "./pages/Contact";
import BlogsPage from "./pages/BlogsPage";
import ComingSoon from "./pages/ComingSoon";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ServiceDetail from "./components/ServicesDe";
import StudyDestinationTemplate from "./components/StudyDestinationTemplate";
import BlogDetail from "./pages/BlogDetail" 

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence initial={false}>
      <Routes location={location} key={location.pathname}>
       
        <Route
          path="/"
          element={
            <PageTransition>
              <Home />
            </PageTransition>
          }
        />
        <Route
          path="/HeroAuto"
          element={
            <PageTransition>
              <HeroAuto />
            </PageTransition>
          }
        />
         {/* ✅ STUDY DESTINATIONS DYNAMIC ROUTE */}
        <Route 
          path="/study/:country" 
          element={<PageTransition><StudyDestinationTemplate /></PageTransition>} 
        />
        <Route
  path="*"
  element={
    <PageTransition>
      <ComingSoon />
    </PageTransition>
  }
/>

        <Route
          path="/services"
          element={
            <PageTransition>
              <ServicesSection />
            </PageTransition>
          }
        />
        <Route path="/services/:slug" element={
            <PageTransition>
              <ServiceDetail />
            </PageTransition>
          } />
        <Route
          path="/contact"
          element={
            <PageTransition>
              <Contact />
            </PageTransition>
          }
        />
        <Route
          path="/blogs"
          element={
            <PageTransition>
              <BlogsPage />
            </PageTransition>
          }
        />
        <Route
          path="/about"
          element={
            <PageTransition>
              <About />
            </PageTransition>
          }
        />
        <Route
          path="/blogs/:slug"
          element={
            <PageTransition>
              <BlogDetail/>
            </PageTransition>
          }
          />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
     <ScrollToTop /> {/* 🔥 THIS FIXES IT */}
      <Layout>
        <AnimatedRoutes />
      </Layout>
             <FloatingWhatsApp />
    </BrowserRouter>
  );
}
